"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplateEditorModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _messageTemplate = require('shared/actions/messageTemplate'); var _messageTemplate2 = _interopRequireDefault(_messageTemplate);
var _templateResolver = require('shared/services/templateResolver');



var _templateEditing = require('shared/services/templateEditing');
var _templateRenderer = require('shared/services/templateRenderer');
var _time = require('shared/services/time');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _templateDefaultHints = require('shared/services/templateDefaultHints');



var _peers = require('shared/selectors/peers');
var _hooks = require('web/services/hooks');
var _Composer = require('web/screens/Broadcast/Wizard/Message/Composer');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _scopes = require('./scopes');
var _useTemplatePreviewContext = require('shared/hooks/templates/useTemplatePreviewContext');
var _TemplateBlanks = require('./TemplateBlanks');

const CUSTOM = '__custom'

const VARIABLE_OPTIONS = [
  { value: '', label: '{ } Insert variable' },
  ..._templateResolver.BUILT_IN_VARIABLES.map(name => ({ value: name, label: name })),
  { value: CUSTOM, label: 'Custom…' },
]

/* A user's name; " (admin)" when they're an admin of the org. */
 const UserName = ({ userKey, isAdmin }) => {
  const name = _hooks.useAppSelector.call(void 0, state => _optionalChain([_peers.selectUserByKey.call(void 0, state, userKey), 'optionalAccess', _ => _.Name]))
  return _react2.default.createElement(_react2.default.Fragment, null,  name || 'Someone' ,  isAdmin ? ' (admin)' : '' )
}; exports.UserName = UserName








































const MODE_KEY = 'messageTemplateEditorMode'
let sessionMode = 'edit'
// Remember Edit or Preview for the session; storage can be unavailable.
const readMode = () => {
  try {
    return window.sessionStorage.getItem(MODE_KEY) === 'preview' ? 'preview' : 'edit'
  } catch (e2) {
    return sessionMode
  }
}
const saveMode = (mode) => {
  sessionMode = mode
  try { window.sessionStorage.setItem(MODE_KEY, mode) } catch (e3) { /* memory only */ }
}

/* The template's fields: name, message (Edit / Preview, variables, fallback
 * hints, blanks) and who can use it. Saves on its own and leaves
 * the frame (a modal, or the Templates dialog's right pane) to the caller. */
 const TemplateEditor = ({
  orgKey, template, draft, blanks, previewContext, onClose, onSaved, renderControls, onDirtyChange, layout = 'modal',
}) => {
  const inPane = layout === 'pane'
  const { options, teams, orgName } = _scopes.useTemplateScopes.call(void 0, orgKey)
  const [mode, setModeState] = _react.useState(readMode)
  const setMode = _react.useCallback.call(void 0, (next) => { saveMode(next); setModeState(next) }, [])
  const { context, sample } = _useTemplatePreviewContext.useTemplatePreviewContext.call(void 0, orgKey, orgName, teams, previewContext)
  // Save as template says whose details Preview shows, when the chat has one patient.
  const previewPatient = previewContext ? _templateResolver.onlyPatient.call(void 0, previewContext) : null
  // Only the author and the org's admins change a shared template's sharing.
  const canShare = !template || template.CanManage !== false
  const [name, setName] = _react.useState.call(void 0, _nullishCoalesce(_nullishCoalesce(_optionalChain([template, 'optionalAccess', _2 => _2.Name]), () => ( _optionalChain([draft, 'optionalAccess', _3 => _3.Name]))), () => ( '')))
  const [ownBody, setOwnBody] = _react.useState.call(void 0, _nullishCoalesce(_nullishCoalesce(_optionalChain([template, 'optionalAccess', _4 => _4.Body]), () => ( _optionalChain([draft, 'optionalAccess', _5 => _5.Body]))), () => ( '')))
  const body = blanks ? blanks.body : ownBody
  const changeBody = blanks ? blanks.setBody : setOwnBody
  const [choice, setChoice] = _react.useState(template ? _templateEditing.scopeChoiceOf.call(void 0, template) : _nullishCoalesce(_optionalChain([draft, 'optionalAccess', _6 => _6.choice]), () => ( 'private')))
  const [customName, setCustomName] = _react.useState(null)
  const [error, setError] = _react.useState(null)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const bodyRef = _react.useRef(null)
  // Variables read as the broadcast composer's tokens and chips, drawn behind
  // the message; one the caret is in shows its text. Save as template's
  // blanks use the tinted copy laid over it instead.
  const showsBlanks = !!blanks && blanks.marks.length > 0
  const [caretAt, setCaretAt] = _react.useState(null)
  const variables = _react.useMemo.call(void 0, () => showsBlanks ? null : _Composer.highlight.call(void 0, body, null, null, caretAt), [showsBlanks, body, caretAt])
  const onBodySelect = _react.useCallback.call(void 0, (e) => {
    const { selectionStart, selectionEnd } = e.currentTarget
    setCaretAt(selectionStart === selectionEnd ? selectionStart : null)
  }, [])
  const onBodyBlur = _react.useCallback.call(void 0, () => setCaretAt(null), [])
  // The highlights scroll with the message.
  const highlightsRef = _react.useRef(null)
  const syncHighlights = _react.useCallback.call(void 0, (e) => {
    if (highlightsRef.current) highlightsRef.current.scrollTop = e.currentTarget.scrollTop
  }, [])
  // Where the caret goes once an inserted variable is in the textarea. Set in
  // the same commit as the new text, so typing that follows lands after it.
  const pendingCaret = _react.useRef(null)
  _react.useLayoutEffect.call(void 0, () => {
    const textarea = bodyRef.current
    if (pendingCaret.current === null || !textarea) return
    textarea.focus()
    textarea.setSelectionRange(pendingCaret.current, pendingCaret.current)
    pendingCaret.current = null
  }, [body])

  // Keep the template's own scope selectable even if it isn't one I could pick.
  const scopeOptions = options.some(o => o.value === choice) || !template
    ? options
    : [...options, { value: choice, label: template.Scope === 'org' ? `Everyone at ${orgName}` : 'Its team' }]

  const insertVariable = _react.useCallback.call(void 0, (variable) => {
    const token = `{{${variable}}}`
    const textarea = bodyRef.current
    const start = _nullishCoalesce(_optionalChain([textarea, 'optionalAccess', _7 => _7.selectionStart]), () => ( body.length))
    const end = _nullishCoalesce(_optionalChain([textarea, 'optionalAccess', _8 => _8.selectionEnd]), () => ( body.length))
    pendingCaret.current = start + token.length
    changeBody(body.slice(0, start) + token + body.slice(end))
  }, [body, changeBody])

  // "Missing first names become "there". Change": Change adds " | " for a typed fallback.
  const hints = _react.useMemo.call(void 0, () => _templateDefaultHints.defaultHints.call(void 0, body, orgName), [body, orgName])
  const changeHint = _react.useCallback.call(void 0, (hint) => {
    const changed = _templateDefaultHints.changeDefault.call(void 0, body, hint)
    pendingCaret.current = changed.caret
    changeBody(changed.body)
  }, [body, changeBody])

  const onPickVariable = _react.useCallback.call(void 0, (value) => {
    if (value === CUSTOM) setCustomName('')
    else if (value) insertVariable(value)
  }, [insertVariable])

  const addCustom = _react.useCallback.call(void 0, () => {
    const insertable = _templateEditing.insertableVariableName.call(void 0, customName)
    if (insertable) {
      insertVariable(insertable)
      setCustomName(null)
    }
  }, [customName, insertVariable])

  const initial = _react.useRef.call(void 0, { name, body, choice })
  const dirty = name !== initial.current.name || body !== initial.current.body || choice !== initial.current.choice
  const reportDirty = _react.useRef.call(void 0, onDirtyChange)
  reportDirty.current = onDirtyChange
  _react.useEffect.call(void 0, () => { _optionalChain([reportDirty, 'access', _9 => _9.current, 'optionalCall', _10 => _10(dirty)]) }, [dirty])

  // The version these fields were filled from: a save after someone else's
  // change is refused instead of overwriting it.
  const openedVersion = _react.useRef.call(void 0, _optionalChain([template, 'optionalAccess', _11 => _11.UpdatedAt]))
  const save = async () => {
    const problem = _templateEditing.validateTemplate.call(void 0, name, body)
    if (problem) return setError(problem)
    setError(null)
    setIsSaving(true)
    // Saved standardized, as the server would store it: {{First Name}} → {{first_name}}.
    const fields = { ..._templateEditing.scopeFromChoice.call(void 0, choice), Name: name.trim(), Body: _templateRenderer.normalizeBody.call(void 0, body) }
    try {
      const saved = template
        ? await _messageTemplate2.default.updateMessageTemplate(orgKey, template.TemplateKey, fields, openedVersion.current)
        : await _messageTemplate2.default.createMessageTemplate(orgKey, fields)
      _optionalChain([onSaved, 'optionalCall', _12 => _12(saved)])
      onClose()
    } catch (e) {
      setError(_templateEditing.saveErrorMessage.call(void 0, e))
      setIsSaving(false)
    }
  }

  const modes = (
  _react2.default.createElement('div', { role: "tablist", 'aria-label': "Message view" , className: "message-template-editor--modes", __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
    , _react2.default.createElement('button', { type: "button", role: "tab", id: "message-template-mode-edit", 'aria-selected': mode === 'edit', 'aria-controls': "message-template-mode-panel", className: "message-template-editor--mode", onClick: () => setMode('edit'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}, "Edit")
    , _react2.default.createElement('button', { type: "button", role: "tab", id: "message-template-mode-preview", 'aria-selected': mode === 'preview', 'aria-controls': "message-template-mode-panel", className: "message-template-editor--mode", onClick: () => setMode('preview'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}, "Preview")
  )
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  template && (
        _react2.default.createElement('p', { className: "message-template-editor--edited", __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}}, "Last edited by "
             , _react2.default.createElement(exports.UserName, { userKey: template.UpdatedBy, isAdmin: template.UpdatedByAdmin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}} ), " · "  ,  _time.formatLongDisplayDate.call(void 0, template.UpdatedAt) 
        )
      )
      , _react2.default.createElement('label', { className: "message-template-editor--label", htmlFor: "message-template-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}}, "Name")
      , _react2.default.createElement(_Form.TextInput, {
        id: "message-template-name",
        value: name,
        maxLength: _templateEditing.MAX_TEMPLATE_NAME,
        placeholder: "Appointment confirmation" ,
        onChange: e => setName(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
      )
      , _react2.default.createElement('div', { className: "message-template-editor--message-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}}
        , _react2.default.createElement('label', { className: "message-template-editor--label", htmlFor: "message-template-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}, "Message")
        ,  inPane && modes 
        , _react2.default.createElement(_Form.SimpleSelect, {
          className: "message-template-editor--insert",
          'aria-label': "Insert variable" ,
          value: "",
          options: VARIABLE_OPTIONS,
          onChange: onPickVariable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
        )
      )
      ,  customName !== null && (
        _react2.default.createElement('div', { className: "message-template-editor--custom", __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}
          , _react2.default.createElement(_Form.TextInput, {
            'aria-label': "Custom variable name"  ,
            placeholder: "appt_date",
            value: customName,
            hasError: !!customName && !_templateEditing.insertableVariableName.call(void 0, customName),
            onChange: e => setCustomName(e.target.value),
            onKeyDown: e => { if (e.key === 'Enter') { e.preventDefault(); addCustom() } },
            autoFocus: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}
          )
          , _react2.default.createElement(_Form.Button, { isOutlined: true, isDisabled: !_templateEditing.insertableVariableName.call(void 0, customName), onClick: addCustom, __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}, "Insert")
          , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: () => setCustomName(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}, "Cancel")
        )
      )
      ,  !inPane && modes 
      , _react2.default.createElement('div', { id: "message-template-mode-panel", role: "tabpanel", 'aria-labelledby': `message-template-mode-${mode}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}
        ,  mode === 'edit'
          ? (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'message-template-editor--body', variables && 'message-template-editor--body-variables'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
                , _react2.default.createElement(_Form.SimpleTextArea, {
                  id: "message-template-body",
                  ref: bodyRef,
                  rows: 6,
                  value: body,
                  maxLength: undefined,
                  placeholder: "Hi {{first_name}}, your {{team_name}} appointment is {{date}}"      ,
                  onScroll: syncHighlights,
                  onSelect: onBodySelect,
                  onBlur: onBodyBlur,
                  onChange: e => changeBody(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
                )
                ,  blanks && showsBlanks && (
                  _react2.default.createElement(_TemplateBlanks.BlankHighlights, { ref: highlightsRef, body: body, marks: blanks.marks, blanks: blanks.blanks, __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}} )
                )
                ,  variables && (
                  _react2.default.createElement('div', { ref: highlightsRef, className: "message-template-editor--highlights message-template-editor--variables" , 'aria-hidden': "true", 'data-testid': "template-variable-highlights", __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
                    ,  variables 
                  )
                )
              )
              ,  hints.map(hint => (
                _react2.default.createElement('p', { key: hint.name, className: "message-template-editor--default-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}
                  ,  hint.text , ' '
                  , _react2.default.createElement('button', { type: "button", className: "message-template-editor--link", onClick: () => changeHint(hint), __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}, "Change")
                )
              ))
            )
            )
          : (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement('p', { className: "message-template-editor--preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 297}}
                ,  _templateResolver.previewTemplate.call(void 0, _templateRenderer.normalizeBody.call(void 0, body), _templateResolver.templateValues.call(void 0, context), _templateResolver.templateDefaults.call(void 0, context)).map((segment, i) => segment.blank
                  ? _react2.default.createElement('mark', { key: i, className: "message-template-editor--blank", __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}},  segment.text )
                  : _react2.default.createElement(_react2.default.Fragment, { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}},  segment.text ),
                )
              )
              ,  sample && _react2.default.createElement('p', { className: "message-template-editor--preview-caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}, "Preview for a sample patient ("     ,  _templateResolver.SAMPLE_PATIENT.FirstName , " " ,  _templateResolver.SAMPLE_PATIENT.LastName , ")") 
              ,  previewPatient && _react2.default.createElement('p', { className: "message-template-editor--preview-caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}}, "Preview for "  ,  previewPatient.FirstName , " " ,  previewPatient.LastName ) 
            )
            )
        
      )
      ,  _optionalChain([blanks, 'optionalAccess', _13 => _13.notice]) && !blanks.reviewing && _react2.default.createElement(_TemplateBlanks.BlankNoticeLine, { notice: blanks.notice, onBlankAll: blanks.blankAll, onReview: blanks.review, onRetry: blanks.retry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}} ) 
      ,  _optionalChain([blanks, 'optionalAccess', _14 => _14.reviewing]) && _react2.default.createElement(_TemplateBlanks.BlankReviewList, { blanks: blanks.blanks, on: blanks.on, onToggle: blanks.toggle, onDone: blanks.closeReview, __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}} ) 
      ,  canShare && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('label', { className: "message-template-editor--label", htmlFor: "message-template-scope", __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}}, "Who can use it"   )
          , _react2.default.createElement(_Form.SimpleSelect, {
            id: "message-template-scope",
            className: "message-template-editor--scope",
            describedBy: "message-template-scope-hint",
            options: scopeOptions,
            value: choice,
            onChange: setChoice, __self: this, __source: {fileName: _jsxFileName, lineNumber: 314}}
          )
        )
      ) 
      , _react2.default.createElement('p', { id: "message-template-scope-hint", className: "message-template-editor--scope-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 324}},  _templateEditing.scopeHint.call(void 0, choice, teams, orgName) )
      ,  error && _react2.default.createElement('p', { className: "message-template-editor--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}},  error ) 
      ,  renderControls({ save, isSaving }) 
    )
  )
}; exports.TemplateEditor = TemplateEditor

const TemplateEditorModal = props => {
  const { template, onClose } = props
  const controls = _react.useCallback.call(void 0, ({ save, isSaving }) => (
    _react2.default.createElement(_Modal.ModalControls, {
      primaryBtnLabel: template ? 'Save changes' : 'Save',
      onPrimaryBtnClick: save,
      isPrimaryLoading: isSaving,
      secondaryBtnLabel: "Cancel",
      onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 334}}
    )
  ), [template, onClose])
  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: true,
      onClose: onClose,
      title: template ? 'Edit template' : 'New template',
      className: "message-template-editor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 343}}

      , _react2.default.createElement(exports.TemplateEditor, { ...props, renderControls: controls, __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}} )
    )
  )
}

exports. default = TemplateEditorModal
